import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';
import * as esgApi from '../../lib/api/esg';

const [LIST_ESG_BOARDS, LIST_ESG_BOARDS_SUCCESS, LIST_ESG_BOARDS_FAILURE] =
  createRequestActionTypes('esg/LIST_ESG_BOARDS');

export const listEsgBoards = createAction(
  LIST_ESG_BOARDS,
  (searchData) => searchData,
);

const listEsgBoardsSaga = createRequestSaga(
  LIST_ESG_BOARDS,
  esgApi.getEsgBoards,
);

const UNLOAD_ESG_BOARDS = 'esg/UNLOAD_ESG_BOARDS';
export const unloadEsgBoards = createAction(UNLOAD_ESG_BOARDS);

export function* esgBoardsSaga() {
  yield takeLatest(LIST_ESG_BOARDS, listEsgBoardsSaga);
}

const initialState = {
  esgBoards: null,
  error: null,
};

const esgBoards = handleActions(
  {
    [LIST_ESG_BOARDS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      esgBoards: data.list.map((item) => ({
        id: item.wrUuid,
        wrUuid: item.wrUuid,
        wrTitle: item.wrTitle,
        wrCategory: item.wrCategory,
        wrContent: item.wrContent,
        wrFileCnt: item.wrFileCnt,
        wrFileUrl: item.wrFileUrl,
        useYn: item.useYn === 'Y',
        crtUsr: item.crtUsr,
        crtNm: item.crtNm,
        crtDt: item.crtDt,
        cngUsr: item.cngUsr,
        cngNm: item.cngNm,
        cngDt: item.cngDt,
      })),
      error: null,
    }),
    [LIST_ESG_BOARDS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [UNLOAD_ESG_BOARDS]: () => initialState,
  },
  initialState,
);

export default esgBoards;
